module.exports = __webpack_public_path__ + "static/media/Rhythm in You.6340463e.jpg";